import { useAsync } from "lib/@hooks/useAsync"
import { ConditionValueSetPicker } from "./condition-value-set-picker"
import { getScheduleTypes } from "./controller/get-schedule-types"

export function ConditionValueScheduleType({ value, onChange }) {
    const types = useAsync(loadTypes, [], [])

    return (
        <ConditionValueSetPicker
            value={value}
            onChange={onChange}
            options={types}
            placeholder="Select schedule types..."
        />
    )

    async function loadTypes() {
        const result = await getScheduleTypes()
        return (result || []).map((t) => t.name).filter(Boolean)
    }
}
